import { IDocument } from 'common/document/interfaces/document';
import { DocumentStatusEnum } from 'common/document/enums/document-status.enum';

const statuses: DocumentStatusEnum[] = [
  DocumentStatusEnum.UPLOADED,
  DocumentStatusEnum.APPROVED,
  DocumentStatusEnum.NEEDS_REVIEW,
];

export const filterDocumentsToReview = (
  documents: IDocument[]
): IDocument[] => {
  return documents.filter((document: IDocument) =>
    statuses.includes(document.status)
  );
};
